import React, { useRef, useState } from 'react';

import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';
import Popover from '@material-ui/core/Popover';
import { ArrowDropDownOutlined } from '@material-ui/icons';
import { createStyles, withStyles } from '@material-ui/core/styles';

import AppBarTab from './AppBarTab';

const styles = (theme) =>
  createStyles({
    dropdownIcon: {
      color: theme.palette.primary.light,

      [theme.breakpoints.down('xl')]: {
        margin: theme.spacing(0, -0.75, 0, 0.75),
      },
      [theme.breakpoints.down('md')]: {
        margin: theme.spacing(0),
      },
    },
  });

const DropdownTabContent = ({ classes, children, items, ...rest }, ref) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(ref);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (prevHandler?) => (event) => {
    setOpen(false);
    prevHandler && prevHandler();
  };

  return (
    <>
      <button {...rest} ref={anchorRef} onClick={handleToggle}>
        {children}
        <ArrowDropDownOutlined className={classes.dropdownIcon} />
      </button>
      <Popover
        open={open}
        anchorEl={anchorRef.current}
        onClose={handleClose()}
        style={{ zIndex: 1500 }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}>
        <Paper elevation={8}>
          <MenuList>
            {React.Children.map(items, (item) =>
              React.cloneElement(item, { onClick: handleClose(item.props.onClick) })
            )}
          </MenuList>
        </Paper>
      </Popover>
    </>
  );
};

const EnhancedDropdownTabContent = withStyles(styles)(React.forwardRef(DropdownTabContent));

const DropdownTab = ({ children, ...rest }) => (
  <AppBarTab
    {...rest}
    textColor="primary"
    component={EnhancedDropdownTabContent}
    items={children}
  />
);

export default DropdownTab;
